/**
 * Round-1 shell placeholder. Every route in `src/routes/AppRoutes.tsx` that
 * doesn't have a real page yet renders one of these instead of 404-ing or
 * crashing — so later batches only ever have to SWAP a component out from
 * under an already-correct, already-tested route + guard, never add a new
 * route (legacy-migration RULES.md: "atomic Full conversion", not a
 * half-migrated route table).
 *
 * `legacyComponent` names the Angular component this page will eventually
 * replace (see legacy-migration audit `docs/audit/components/
 * secure.grabbitbot.com.md` §3a for the full table) — purely documentation,
 * shown so a reviewer can cross-check against the audit without re-deriving
 * the mapping.
 */
export function PlaceholderPage({ title, legacyComponent }: { title: string; legacyComponent?: string }) {
  return (
    <div className="portal-card">
      <span className="portal-placeholder-badge">Not yet ported</span>
      <h1>{title}</h1>
      <p className="portal-text-muted">
        This page is a round-1 shell placeholder — routing, layout and access
        control are live, the real content is not implemented yet.
        {legacyComponent && (
          <>
            {' '}
            Legacy component: <code>{legacyComponent}</code>.
          </>
        )}
      </p>
    </div>
  )
}
